import type React from "react";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { useSessionUserInitial } from "@/hooks/Network/useSessionUserInitial";

import type { ProjectId } from "./ProjectContext";
import { ProjectContext } from "./ProjectContext";
import { StartupLoading } from "./StartupLoading";

interface QuickReplyUserLoaderProps {
  children: React.ReactNode;
  projectId: string;
}

/** Ensures self data for the token project and exposes its scope. Root language remains route-owned. */
export function QuickReplyUserLoader({ children, projectId }: QuickReplyUserLoaderProps): React.ReactNode {
  const { data: user, error } = useSessionUserInitial(projectId);
  if (!user) {
    return error ? <ErrorPage error={error} /> : <StartupLoading />;
  }

  return (
    <ProjectContext value={{ projectId: user.projectId as ProjectId, projectSlug: user.project.slug }}>
      {children}
    </ProjectContext>
  );
}
